import { Controller } from "@hotwired/stimulus"
import { Toast } from "bootstrap"

// Bootstrap's toast component, unlike alert/dropdown/collapse (data-bs-dismiss="alert" and
// friends work with no JS of ours at all), doesn't show or autohide itself just from being
// present in the DOM -- it needs to actually be instantiated. autohide and delay come from the
// data-bs-autohide/data-bs-delay attributes already on the element (see the flash toast markup
// in application.html.erb), not hardcoded here, so a future flash type could opt out or use a
// different delay without touching this controller.
export default class extends Controller {
  connect() {
    Toast.getOrCreateInstance(this.element).show()
  }
}
